export default __webpack_public_path__ + "static/media/olivia.524ace2d.jpg";